import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import * as BS from 'react-bootstrap';
import * as BSEx from '../../BootstrapExtends';
import Box from '../../atoms/Box';

const scope =
  'frontend.components.SpreadsheetReportConfigs.Form.SheetMappingForm';

const SheetMappingFormSkeleton = () => {
  return (
    <BS.Form horizontal style={{ lineHeight: '1' }}>
      <Box>
        <Box.Body>
          {/* Header Row */}
          <BS.Row style={{ marginBottom: '15px' }}>
            <BS.Col sm={2} style={{ fontWeight: 'bold', textAlign: 'right' }}>
              {I18n.t(`${scope}.field.currentSheetName.label`)}
            </BS.Col>
            <BS.Col sm={10} style={{ fontWeight: 'bold' }}>
              {I18n.t(`${scope}.field.sourceSheetName.label`)}
            </BS.Col>
          </BS.Row>

          {/* Sheet Mapping Fields Skeleton */}
          {[1, 2, 3].map((index) => (
            <BSEx.FormGroupInline
              key={index}
              label={<Skeleton height={20} width={100} />}
            >
              <Skeleton height={34} />
            </BSEx.FormGroupInline>
          ))}
        </Box.Body>

        <Box.Footer>
          <BSEx.FormGroup>
            <BS.Col smOffset={2} sm={10}>
              <div style={{ display: 'inline-block', marginRight: '10px' }}>
                <Skeleton height={34} width={54} />
              </div>
              <div style={{ display: 'inline-block' }}>
                <Skeleton height={34} width={54} />
              </div>
            </BS.Col>
          </BSEx.FormGroup>
        </Box.Footer>
      </Box>
    </BS.Form>
  );
};

export default SheetMappingFormSkeleton;
